import { useState } from "react"
import { SendsReceiptsOption, SendsReceiptsValue } from "../../types"
import { sessionApiClient } from "@planningcenter/cc-api-client"
import { RadioButton } from "../../../components/RadioButton"
import { AlertMessage } from "source/shared/components/AlertMessage"

interface SendsReceiptsSelectorProps {
  value: SendsReceiptsValue
}

export function SendsReceiptsSelector({ value }: SendsReceiptsSelectorProps) {
  const sendReceiptsOptions: SendsReceiptsOption[] = [
    { label: "Always email me donation receipts", value: "always" },
    { label: "Never email me donation receipts", value: "never" },
  ]

  const [sendsReceipts, setSendsReceipts] = useState<SendsReceiptsValue>(value)

  const [isSaving, setIsSaving] = useState<boolean>(false)
  const [hasErrors, setHasErrors] = useState<boolean>(false)

  const updateSendsReceiptsValue = async (newValue: SendsReceiptsValue) => {
    setIsSaving(true)
    setHasErrors(false)

    try {
      const response = await sessionApiClient.patch("/giving/v2/me", {
        data: {
          attributes: {
            sends_receipts: newValue,
          },
        },
      })
      setSendsReceipts(response.data.attributes.sends_receipts)
    } catch (error) {
      setHasErrors(true)
    } finally {
      setIsSaving(false)
    }
  }

  return (
    <fieldset>
      <div className="d-f fd-c g-1">
        <legend>Send receipts when I give:</legend>
        {hasErrors && (
          <AlertMessage type="error" icon="general#exclamation-triangle">
            Something went wrong. Please try again.
          </AlertMessage>
        )}
        <div className="d-f fd-c g-4p pl-2">
          {sendReceiptsOptions.map((type, index) => (
            <RadioButton
              key={index}
              value={type.value}
              checked={sendsReceipts === type.value}
              disabled={isSaving}
              onChange={() => updateSendsReceiptsValue(type.value)}
            >
              {type.label}
            </RadioButton>
          ))}
        </div>
      </div>
    </fieldset>
  )
}
